import { render } from "./TemplateA.vue?vue&type=template&id=272017c9"
import script from "./TemplateA.vue?vue&type=script&lang=js"
export * from "./TemplateA.vue?vue&type=script&lang=js"

import "./TemplateA.vue?vue&type=style&index=0&id=272017c9&lang=css"
script.render = render

export default script